/**
 * @generated SignedSource<<45b13792c2a67860a1a3f255ca096a9c>>
 * @relayHash 7d884945e43cd762b79a25b956abcba1
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID b658d4873910d5690188b027f1f6dfa9f5b1a72e5b60a83978f900e51e0a7d29

import type { ConcreteRequest, Mutation } from 'relay-runtime';
export type JiraIssueLinkDirection = "BOTH" | "INWARD" | "OUTWARD" | "%future added value";
export type JiraSingleValueFieldOperations = "SET" | "%future added value";
export type JiraUpdateIssueLinkRelationshipTypeFieldInput = {
  id: string;
  operation: JiraUpdateIssueLinkRelationshipTypeFieldOperationInput;
};
export type JiraUpdateIssueLinkRelationshipTypeFieldOperationInput = {
  operation: JiraSingleValueFieldOperations;
  update: JiraIssueLinkRelationshipTypeUpdateInput;
};
export type JiraIssueLinkRelationshipTypeUpdateInput = {
  direction?: JiraIssueLinkDirection | null | undefined;
  issueLinkId: string;
  issueLinkTypeId?: string | null | undefined;
};
export type ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation$variables = {
  input: JiraUpdateIssueLinkRelationshipTypeFieldInput;
};
export type ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation$data = {
  readonly jira: {
    readonly updateIssueLinkRelationshipTypeField: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly errorType: string | null | undefined;
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly issueLink: {
          readonly direction: JiraIssueLinkDirection | null | undefined;
          readonly id: string | null | undefined;
          readonly relationName: string | null | undefined;
          readonly type: {
            readonly id: string;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation$rawResponse = {
  readonly jira: {
    readonly updateIssueLinkRelationshipTypeField: {
      readonly errors: ReadonlyArray<{
        readonly extensions: {
          readonly __typename: "BulkMutationErrorExtension";
          readonly errorType: string | null | undefined;
          readonly id: string;
          readonly statusCode: number | null | undefined;
        } | {
          readonly __typename: string;
          readonly errorType: string | null | undefined;
          readonly statusCode: number | null | undefined;
        } | null | undefined;
        readonly message: string | null | undefined;
      }> | null | undefined;
      readonly field: {
        readonly id: string;
        readonly issueLink: {
          readonly direction: JiraIssueLinkDirection | null | undefined;
          readonly id: string | null | undefined;
          readonly relationName: string | null | undefined;
          readonly type: {
            readonly id: string;
          } | null | undefined;
        } | null | undefined;
      } | null | undefined;
      readonly success: boolean;
    } | null | undefined;
  } | null | undefined;
};
export type ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation = {
  rawResponse: ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation$rawResponse;
  response: ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation$data;
  variables: ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "input",
    "variableName": "input"
  }
],
v2 = {
  "kind": "ScalarField",
  "name": "success"
},
v3 = {
  "kind": "ScalarField",
  "name": "message"
},
v4 = {
  "kind": "ScalarField",
  "name": "statusCode"
},
v5 = {
  "kind": "ScalarField",
  "name": "errorType"
},
v6 = {
  "kind": "ScalarField",
  "name": "id"
},
v7 = [
  (v6/*: any*/)
],
v8 = {
  "concreteType": "JiraIssueLinkRelationshipTypeField",
  "kind": "LinkedField",
  "name": "field",
  "plural": false,
  "selections": [
    (v6/*: any*/),
    {
      "concreteType": "JiraIssueLink",
      "kind": "LinkedField",
      "name": "issueLink",
      "plural": false,
      "selections": [
        (v6/*: any*/),
        {
          "kind": "ScalarField",
          "name": "direction"
        },
        {
          "kind": "ScalarField",
          "name": "relationName"
        },
        {
          "concreteType": "JiraIssueLinkType",
          "kind": "LinkedField",
          "name": "type",
          "plural": false,
          "selections": (v7/*: any*/)
        }
      ]
    }
  ]
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateIssueLinkRelationshipTypeFieldPayload",
            "kind": "LinkedField",
            "name": "updateIssueLinkRelationshipTypeField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      (v4/*: any*/),
                      (v5/*: any*/)
                    ]
                  }
                ]
              },
              (v8/*: any*/)
            ]
          }
        ]
      }
    ],
    "type": "Mutation"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation",
    "selections": [
      {
        "concreteType": "JiraMutation",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "args": (v1/*: any*/),
            "concreteType": "JiraUpdateIssueLinkRelationshipTypeFieldPayload",
            "kind": "LinkedField",
            "name": "updateIssueLinkRelationshipTypeField",
            "plural": false,
            "selections": [
              (v2/*: any*/),
              {
                "concreteType": "MutationError",
                "kind": "LinkedField",
                "name": "errors",
                "plural": true,
                "selections": [
                  (v3/*: any*/),
                  {
                    "kind": "LinkedField",
                    "name": "extensions",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "__typename"
                      },
                      (v4/*: any*/),
                      (v5/*: any*/),
                      {
                        "kind": "InlineFragment",
                        "selections": (v7/*: any*/),
                        "type": "BulkMutationErrorExtension"
                      }
                    ]
                  }
                ]
              },
              (v8/*: any*/)
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "b658d4873910d5690188b027f1f6dfa9f5b1a72e5b60a83978f900e51e0a7d29",
    "metadata": {},
    "name": "ui_JiraIssueFieldLinkRelationshipInlineEditFull_LinkRelationshipTypeCell_Mutation",
    "operationKind": "mutation",
    "text": null
  }
};
})();

(node as any).hash = "2f0a2d2138cd528cd40ded3dce91df75";

export default node;
